import LeadDBSummaryActions from "@redux/feature/Lead/action/LeadDBSummaryActions";
import LeadDashboardActions from "@redux/feature/Lead/action/LeadDashboardActions";
import EmployeeListActions from "@redux/feature/Lead/action/EmployeeListActions";
import ClientProfileDetailsActions from "@redux/feature/Lead/action/ClientProfileDetailsActions";
import ViewLeadActions from "@redux/feature/Lead/action/ViewLeadActions";
import AddEditLeadPastIntractionActions from "@redux/feature/Lead/action/AddEditPastIntractionActions";
import LeadOtpActions from "@redux/feature/Lead/action/LeadOtpActions";
import PurchaseHistoryActions from "@redux/feature/Lead/action/PurchaseHistoryActions";
export default (function () {
    return {
        leads: {
            leadDashboard: new LeadDashboardActions(),
            leadDBSummaryAction: new LeadDBSummaryActions(),
            employeeList: new EmployeeListActions(),
            clientProfileDetails: new ClientProfileDetailsActions(),
            getViewLeadData: new ViewLeadActions(),
            addEditLeadPastIntraction: new AddEditLeadPastIntractionActions(),
            getLeadOtp: new LeadOtpActions(),
            purchaseHistory: new PurchaseHistoryActions(),
        },
    };
});
